import { use } from 'react';
import AvailabilityFiltersContext from '../availabilityFilters.context';
const useAvailabilityFiltersHandlers = () => {
    const { handleSaveFilters } = use(AvailabilityFiltersContext);
    return { handleSaveFilters };
};
export default useAvailabilityFiltersHandlers;
